import React from 'react';

const Page404 = () => {
  return <div>Page not found</div>;
};

export default Page404;
